<template>
  <section class="bm-title">
    <header class="bm-title__head">
      <div class="bm-title__crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          云库工作台 › 批量修改 ›
          <strong>商品详情图</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改商品详情图</h1>
      <nav>
        <button
          class="mode-range"
          :class="{ active: mode === 'range' }"
          @click="switchMode('range')"
        >
          按范围修改
        </button>
        <button
          class="mode-goods"
          :class="{ active: mode === 'goods' }"
          @click="switchMode('goods')"
        >
          按商品修改
        </button>
      </nav>
    </header>
    <main class="bm-title__body">
      <section v-if="mode === 'range'" class="bm-title__filter">
        <div v-for="field in fields" :key="field.key" class="bm-title__field">
          <label>{{ field.label }}</label>
          <el-select
            v-if="field.select"
            v-model="filterValues[field.key]"
            class="bm-title__filter-select"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="o in optionsFor(field.key)"
              :key="o.value"
              :label="o.label"
              :value="o.value"
            />
          </el-select>
          <div v-else-if="field.range" class="bm-title__date-range">
            <input
              v-model="addTime[0]"
              type="date"
              class="bm-title__date-input"
            />
            <span>—</span>
            <input
              v-model="addTime[1]"
              type="date"
              class="bm-title__date-input"
            />
          </div>
          <el-select
            v-else-if="
              field.key === 'group_id' || field.key === 'child_group_id'
            "
            v-model="filterValues[field.key]"
            class="bm-title__filter-select"
            @change="field.key === 'group_id' && onGroupChange()"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="o in optionsFor(field.key)"
              :key="o.value"
              :label="o.label"
              :value="o.value"
            />
          </el-select>
          <input
            v-else
            v-model="filterValues[field.key]"
            :placeholder="field.placeholder"
          />
        </div>
        <footer>
          <div>
            <button @click="previewBatch">查询</button>
            <button class="plain" @click="reset">重置</button>
          </div>
        </footer>
      </section>
      <section v-else class="bm-title__picked">
        <button @click="openSelector">选择商品</button>
        <span>{{
          selected.length
            ? "已选择 " + selected.length + " 个商品"
            : "请先选择需要修改的商品"
        }}</span>
      </section>
      <section class="bm-title__methods">
        <header>
          <p></p>
          修改内容
        </header>
        <div class="bm-title__methods-wrapper">
          <article v-for="method in methods" :key="method.id">
            <el-checkbox
              :value="form.selectedMethod === method.id"
              @change="onMethodChange(method.id)"
              class="bm-title__method-name"
            >
              方式{{ method.id }}：{{ method.name }}
            </el-checkbox>
            <div class="bm-title__method-content">
              <template v-if="method.id === 1"> </template>
              <template v-else-if="method.id === 2">
                <el-checkbox-group
                  v-model="form.deletePositions"
                  :disabled="form.selectedMethod !== method.id"
                >
                  <el-checkbox label="delete_first_1"
                    >删除第1张图片</el-checkbox
                  >
                  <el-checkbox label="delete_first_2"
                    >删除第2张图片</el-checkbox
                  >
                  <el-checkbox label="delete_first_3"
                    >删除第3张图片</el-checkbox
                  >
                  <el-checkbox label="delete_last_1"
                    >删除最后1张图片</el-checkbox
                  >
                  <el-checkbox label="delete_last_2"
                    >删除倒数第2张图片</el-checkbox
                  >
                  <el-checkbox label="delete_last_3"
                    >删除倒数第3张图片</el-checkbox
                  >
                </el-checkbox-group>
                <div class="bm-title__inline">
                  <span>删除第</span>
                  <el-input-number
                    class="price-number-input"
                    v-model="form.deleteCustomIndex"
                    :disabled="form.selectedMethod !== method.id"
                    :min="0"
                    :max="999"
                    :step="1"
                    :precision="0"
                    controls-position="right"
                    placeholder="X"
                  />
                  <span>张图片</span>
                  <span style="margin-left: 20px">删除倒数第</span>
                  <el-input-number
                    class="price-number-input"
                    v-model="form.deleteCustomLastIndex"
                    :disabled="form.selectedMethod !== method.id"
                    :min="0"
                    :max="999"
                    :step="1"
                    :precision="0"
                    controls-position="right"
                    placeholder="X"
                  />
                  <span>张图片</span>
                </div>
              </template>
              <template v-else-if="method.id === 3">
                <div class="image-select-group">
                  <span>过滤详情图片</span>
                  <button
                    class="upload-box small"
                    :class="{
                      'is-disabled': form.selectedMethod !== method.id,
                    }"
                    @click="openImageSelector('filter')"
                  >
                    <span>+</span>
                    <small>选择图片</small>
                  </button>
                  <div v-if="form.filterImages.length" class="selected-images">
                    <div
                      v-for="(img, idx) in form.filterImages"
                      :key="idx"
                      class="image-item"
                    >
                      <img :src="img" alt="" />
                      <button
                        class="remove-img"
                        @click="form.filterImages.splice(idx, 1)"
                        :disabled="form.selectedMethod !== method.id"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="method.id === 4">
                <div class="replace-list">
                  <div
                    v-for="(item, index) in form.replaceList"
                    :key="index"
                    class="replace-item"
                  >
                    <span>查找</span>
                    <button
                      v-if="!item.find"
                      class="upload-box small"
                      :class="{
                        'is-disabled': form.selectedMethod !== method.id,
                      }"
                      @click="openImageSelector('replace_find', index)"
                    >
                      <span>+</span>
                      <small>选择图片</small>
                    </button>
                    <div v-else class="image-item">
                      <img :src="item.find" alt="" />
                      <button
                        class="remove-img"
                        @click="item.find = ''"
                        :disabled="form.selectedMethod !== method.id"
                      >
                        ×
                      </button>
                    </div>
                    <span>替换为</span>
                    <button
                      v-if="!item.to"
                      class="upload-box small"
                      :class="{
                        'is-disabled': form.selectedMethod !== method.id,
                      }"
                      @click="openImageSelector('replace_to', index)"
                    >
                      <span>+</span>
                      <small>选择图片</small>
                    </button>
                    <div v-else class="image-item">
                      <img :src="item.to" alt="" />
                      <button
                        class="remove-img"
                        @click="item.to = ''"
                        :disabled="form.selectedMethod !== method.id"
                      >
                        ×
                      </button>
                    </div>
                    <button
                      size="mini"
                      v-if="index > 0"
                      :disabled="form.selectedMethod !== method.id"
                      class="danger"
                      @click="form.replaceList.splice(index, 1)"
                    >
                      删除
                    </button>
                    <button
                      size="mini"
                      v-if="index === 0"
                      class="add-btn-inline"
                      :disabled="form.selectedMethod !== method.id"
                      @click="form.replaceList.push({ find: '', to: '' })"
                    >
                      + 添加替换
                    </button>
                  </div>
                </div>
              </template>
              <template v-else-if="method.id === 5">
                <div class="bm-title__inline">
                  <span>添加首部图片</span>
                  <button
                    class="upload-box small"
                    :class="{
                      'is-disabled': form.selectedMethod !== method.id,
                    }"
                    @click="openImageSelector('add_head')"
                  >
                    <span>+</span>
                    <small>选择图片</small>
                  </button>
                  <div
                    v-for="(img, idx) in form.addHeadImages"
                    :key="idx"
                    class="image-item"
                  >
                    <img :src="img" alt="" />
                    <button
                      class="remove-img"
                      @click="form.addHeadImages.splice(idx, 1)"
                      :disabled="form.selectedMethod !== method.id"
                    >
                      ×
                    </button>
                  </div>
                </div>
                <div class="bm-title__inline">
                  <span>添加尾部图片</span>
                  <button
                    class="upload-box small"
                    :class="{
                      'is-disabled': form.selectedMethod !== method.id,
                    }"
                    @click="openImageSelector('add_tail')"
                  >
                    <span>+</span>
                    <small>选择图片</small>
                  </button>
                  <div
                    v-for="(img, idx) in form.addTailImages"
                    :key="idx"
                    class="image-item"
                  >
                    <img :src="img" alt="" />
                    <button
                      class="remove-img"
                      @click="form.addTailImages.splice(idx, 1)"
                      :disabled="form.selectedMethod !== method.id"
                    >
                      ×
                    </button>
                  </div>
                </div>
              </template>
              <template v-else-if="method.id === 6">
                <span>添加详情图片</span>
                <button
                  class="upload-box small"
                  :class="{ 'is-disabled': form.selectedMethod !== method.id }"
                  @click="openImageSelector('add_position')"
                >
                  <span>+</span>
                  <small>选择图片</small>
                </button>
                <div
                  v-for="(img, idx) in form.addPositionImages"
                  :key="idx"
                  class="image-item"
                >
                  <img :src="img" alt="" />
                  <button
                    class="remove-img"
                    @click="form.addPositionImages.splice(idx, 1)"
                    :disabled="form.selectedMethod !== method.id"
                  >
                    ×
                  </button>
                </div>
                <span>插入到第</span>
                <el-input-number
                  class="price-number-input"
                  v-model="form.insertPosition"
                  :disabled="form.selectedMethod !== method.id"
                  :min="1"
                  :max="999"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="X"
                />
                <span>张后面</span>
              </template>
              <template v-else-if="method.id === 7">
                <span>将</span>
                <el-select
                  v-model="form.mainImageToDetail"
                  :disabled="form.selectedMethod !== method.id"
                  placeholder="选择主图"
                >
                  <el-option label="第1张主图" value="1" />
                  <el-option label="第2张主图" value="2" />
                  <el-option label="第3张主图" value="3" />
                  <el-option label="第4张主图" value="4" />
                  <el-option label="第5张主图" value="5" />
                </el-select>
                <span>添加到详情图中</span>
              </template>
              <template v-else-if="method.id === 8">
                <div class="delete-detail-group">
                  <div class="delete-row">
                    <el-checkbox
                      :value="form.deleteOption === 'head_tail'"
                      @change="
                        form.deleteOption =
                          form.deleteOption === 'head_tail' ? null : 'head_tail'
                      "
                      :disabled="form.selectedMethod !== method.id"
                    >
                    </el-checkbox>
                    <span>删除头部第</span>
                    <el-input-number
                      class="price-number-input"
                      v-model="form.deleteHeadCount"
                      :disabled="
                        form.selectedMethod !== method.id ||
                        form.deleteOption !== 'head_tail'
                      "
                      :min="0"
                      :max="999"
                      :step="1"
                      :precision="0"
                      controls-position="right"
                      placeholder="X"
                    />
                    <span>张</span>
                    <span style="margin-left: 20px">删除尾部第</span>
                    <el-input-number
                      class="price-number-input"
                      v-model="form.deleteTailCount"
                      :disabled="
                        form.selectedMethod !== method.id ||
                        form.deleteOption !== 'head_tail'
                      "
                      :min="0"
                      :max="999"
                      :step="1"
                      :precision="0"
                      controls-position="right"
                      placeholder="X"
                    />
                    <span>张</span>
                  </div>
                  <div class="delete-row">
                    <el-checkbox
                      :value="form.deleteOption === 'first_last'"
                      @change="
                        form.deleteOption =
                          form.deleteOption === 'first_last'
                            ? null
                            : 'first_last'
                      "
                      :disabled="form.selectedMethod !== method.id"
                    >
                    </el-checkbox>
                    <span>删除前</span>
                    <el-input-number
                      class="price-number-input"
                      v-model="form.deleteFirstCount"
                      :disabled="
                        form.selectedMethod !== method.id ||
                        form.deleteOption !== 'first_last'
                      "
                      :min="0"
                      :max="999"
                      :step="1"
                      :precision="0"
                      controls-position="right"
                      placeholder="X"
                    />
                    <span>张</span>
                    <span style="margin-left: 20px">删除后</span>
                    <el-input-number
                      class="price-number-input"
                      v-model="form.deleteLastCount"
                      :disabled="
                        form.selectedMethod !== method.id ||
                        form.deleteOption !== 'first_last'
                      "
                      :min="0"
                      :max="999"
                      :step="1"
                      :precision="0"
                      controls-position="right"
                      placeholder="X"
                    />
                    <span>张</span>
                  </div>
                  <div class="delete-row">
                    <el-checkbox
                      :value="form.deleteOption === 'keep'"
                      @change="
                        form.deleteOption =
                          form.deleteOption === 'keep' ? null : 'keep'
                      "
                      :disabled="form.selectedMethod !== method.id"
                    >
                    </el-checkbox>
                    <span>仅保留第一张起后的</span>
                    <el-input-number
                      class="price-number-input"
                      v-model="form.keepCount"
                      :disabled="
                        form.selectedMethod !== method.id ||
                        form.deleteOption !== 'keep'
                      "
                      :min="0"
                      :max="999"
                      :step="1"
                      :precision="0"
                      controls-position="right"
                      placeholder="X"
                    />
                    <span>张</span>
                  </div>
                  <div class="delete-row">
                    <el-checkbox
                      :value="form.deleteOption === 'delete_all'"
                      @change="
                        form.deleteOption =
                          form.deleteOption === 'delete_all'
                            ? null
                            : 'delete_all'
                      "
                      :disabled="form.selectedMethod !== method.id"
                    >
                      删除所有详情图，并新增
                    </el-checkbox>
                    <button
                      class="upload-box small"
                      :class="{
                        'is-disabled': form.deleteOption !== 'delete_all',
                      }"
                      @click="openImageSelector('delete_all_add')"
                    >
                      <span>+</span>
                      <small>选择图片</small>
                    </button>
                    <div
                      v-for="(img, idx) in form.deleteAllAddImages"
                      :key="idx"
                      class="image-item"
                    >
                      <img :src="img" alt="" />
                      <button
                        class="remove-img"
                        @click="form.deleteAllAddImages.splice(idx, 1)"
                        :disabled="
                          form.selectedMethod !== method.id ||
                          form.deleteOption !== 'delete_all'
                        "
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </article>
        </div>
      </section>
      <section v-if="preview" class="bm-title__preview">
        <header>
          预览：共
          <b>{{
            preview.product_count || preview.total || previewGoods.length || 0
          }}</b>
          个商品，跳过
          <b>{{
            preview.skipped_product_count ||
            preview.skipped_product_count_total ||
            0
          }}</b>
          个商品，失败
          <b>{{ preview.failed_product_count || preview.failed_count || 0 }}</b>
          个商品
        </header>
        <table>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>详情图信息（拖拽可以设置顺序）</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in previewGoods"
              :key="String(item.product_id || index)"
              :class="{
                'is-excluded': excludedProductIds.includes(
                  String(item.product_id)
                ),
              }"
            >
              <td>
                <el-image
                  class="bm-title__image"
                  :src="imageOf(item)"
                  fit="cover"
                  :preview-src-list="[imageOf(item)]"
                />
                <div>
                  <p>{{ item.title || item.product_title }}</p>
                  <div class="preview-meta">
                    <small>商品ID：{{ item.product_id }}</small>
                    <small
                      >来源ID：{{ item.source_product_id || "无数据" }}</small
                    >
                    <small>数据源：{{ sourceLabel(item.source_web) }}</small>
                  </div>
                </div>
              </td>
              <td>
                <div v-if="form.selectedMethod === 1 && item.product_id">
                  <draggable
                    :value="getEditingImages(item.product_id)"
                    @input="updateEditingImages(item.product_id, $event)"
                    class="detail-images-preview"
                    :options="{ animation: 200 }"
                    @start="onDragStart(item.product_id)"
                    @end="onDragEnd(item.product_id)"
                  >
                    <div
                      v-for="(img, idx) in getEditingImages(item.product_id)"
                      :key="idx"
                      class="image-preview-item"
                      :title="'拖拽可以设置顺序'"
                    >
                      <el-image
                        :src="img.url"
                        fit="cover"
                        :preview-src-list="
                          getEditingImages(item.product_id).map((i) => i.url)
                        "
                        :initial-index="idx"
                        style="width: 100%; height: 100%; cursor: move"
                      >
                        <div slot="placeholder" class="image-loading">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                      <div class="image-actions-overlay">
                        <button
                          @click.stop="replaceImageInline(item.product_id, idx)"
                          class="icon-btn-overlay"
                          title="替换"
                        >
                          <i class="el-icon-refresh"></i>
                        </button>
                        <button
                          @click.stop="deleteImageInline(item.product_id, idx)"
                          class="icon-btn-overlay"
                          :disabled="
                            getEditingImages(item.product_id).length <= 1
                          "
                          title="删除"
                        >
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </div>
                    <div
                      class="image-preview-item add-image"
                      @click="addNewImageInline(item.product_id)"
                      title="添加图片"
                    >
                      <span class="add-icon">+</span>
                    </div>
                  </draggable>
                </div>
                <div v-else>
                  <div class="detail-images-preview">
                    <!-- 显示所有图片，包括删除的，保持原始位置 -->
                    <div
                      v-for="(img, idx) in item.detail_images"
                      :key="idx"
                      class="image-preview-item"
                      :class="{
                        'image-added': img.change_type === 'added',
                        'image-replaced': img.change_type === 'replaced',
                        'image-moved': img.change_type === 'moved',
                        'image-deleted': img.change_type === 'deleted',
                      }"
                    >
                      <el-image
                        :src="img.url"
                        fit="cover"
                        :preview-src-list="item.detail_images.filter(i => i.change_type !== 'deleted').map((i) => i.url)"
                        :initial-index="getPreviewIndex(item.detail_images, idx)"
                        style="width: 100%; height: 100%"
                      >
                        <div slot="placeholder" class="image-loading">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                      <div v-if="img.change_type === 'added'" class="change-badge badge-added">
                        新增
                      </div>
                      <div v-if="img.change_type === 'replaced'" class="change-badge badge-replaced">
                        替换
                      </div>
                      <div v-if="img.change_type === 'moved'" class="change-badge badge-moved">
                        移动
                      </div>
                      <div v-if="img.change_type === 'deleted'" class="change-badge badge-deleted">
                        已删除
                      </div>
                      <div v-if="img.change_type === 'deleted'" class="deleted-overlay"></div>
                    </div>
                  </div>
                  <div
                    v-if="!item.detail_images || item.detail_images.length === 0"
                    style="color: #999"
                  >
                    暂无详情图
                  </div>
                </div>
              </td>
              <td>
                {{ item.status_text || item.status || "待处理" }}
                <span v-if="item.error_msg">{{ item.error_msg }}</span>
              </td>
              <td class="action-cell">
                <button
                  v-if="
                    form.selectedMethod === 1 && hasChanges(item.product_id)
                  "
                  @click="saveProductImages(item.product_id)"
                  :disabled="savingImages"
                  class="btn-save-action"
                >
                  {{ savingImages ? "保存中..." : "保存" }}
                </button>
                <!-- <button v-if="form.selectedMethod === 1 && hasChanges(item.product_id)" @click="cancelEditInline(item.product_id)" class="btn-cancel-action">取消</button> -->
                <button @click="toggleExclude(item)">
                  {{
                    excludedProductIds.includes(String(item.product_id))
                      ? "恢复修改"
                      : "排除修改"
                  }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-title__pagination">
          <button
            :disabled="previewPage.page <= 1"
            @click="previewBatchPage(previewPage.page - 1)"
          >
            上一页
          </button>
          <span>第 {{ previewPage.page }} / {{ pageCount }} 页</span>
          <button
            :disabled="previewPage.page >= pageCount"
            @click="previewBatchPage(previewPage.page + 1)"
          >
            下一页
          </button>
          <select
            v-model.number="previewPage.limit"
            @change="previewBatchPage(1)"
          >
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </footer>
      </section>
      <p
        v-if="preview && preview.warnings && preview.warnings.length"
        class="bm-title__warnings"
      >
        {{
          preview.warnings
            .map((item) => item.message + "（商品ID：" + item.product_id + "）")
            .join("；")
        }}
      </p>
    </main>
    <footer class="bm-title__bottom">
      <button class="preview" :disabled="previewLoading" @click="previewBatch">
        {{ previewLoading ? "预览中" : "修改内容预览" }}
      </button>
      <button
        class="start"
        :disabled="!canCreate || submitting"
        @click="createBatch"
      >
        {{ submitting ? "提交中" : "开始批量修改" }}
      </button>
    </footer>
    <div v-if="selecting" class="bm-title__mask">
      <div class="bm-title__select-modal">
        <header>
          <strong>选择修改商品</strong>
          <button @click="selecting = false">×</button>
        </header>
        <nav>
          <button
            :class="{ active: selectorTab === 'all' }"
            @click="switchSelectorTab('all')"
          >
            选择商品
          </button>
          <button
            :class="{ active: selectorTab === 'selected' }"
            @click="switchSelectorTab('selected')"
          >
            已选择
          </button>
        </nav>
        <div class="bm-title__selector-toolbar">
          <div class="bm-title__select-filter">
            <el-select
              v-model="selectorFilters.group_id"
              popper-class="bm-title__select-popper"
              class="bm-title__group-select"
              @change="loadSelectorGroups"
            >
              <el-option label="全部分组" value="" />
              <el-option
                v-for="g in groupList"
                :key="g.id"
                :label="g.name || g.group_name"
                :value="g.id"
              />
            </el-select>
            <el-select
              v-model="selectorFilters.child_group_id"
              popper-class="bm-title__select-popper"
              class="bm-title__group-select"
              @change="loadGoods(1)"
            >
              <el-option label="全部子分组" value="" />
              <el-option
                v-for="g in selectorChildGroups"
                :key="g.id"
                :label="g.name || g.group_name"
                :value="g.id"
              />
            </el-select>
            <input
              v-model="selectorFilters.source_product_id"
              placeholder="来源ID"
            />
            <input v-model="selectorFilters.keyword" placeholder="商品标题" />
            <button @click="loadGoods(1)">查询</button>
          </div>
          <div class="bm-title__selector-pagination">
            <button
              :disabled="selectorPage.page <= 1"
              @click="loadGoods(selectorPage.page - 1)"
            >
              上一页
            </button>
            <span
              >{{ selectorPage.page }} /
              {{
                Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))
              }}</span
            >
            <button
              :disabled="
                selectorPage.page >=
                Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))
              "
              @click="loadGoods(selectorPage.page + 1)"
            >
              下一页
            </button>
            <el-select
              v-model="selectorPage.limit"
              popper-class="bm-title__select-popper"
              class="bm-title__page-size"
              @change="loadGoods(1)"
            >
              <el-option
                v-for="n in [10, 20, 50]"
                :key="n"
                :label="n + '条/页'"
                :value="n"
              />
            </el-select>
          </div>
          <label class="bm-title__select-all">
            <el-checkbox
              :value="selectorPageAllSelected"
              @change="togglePageGoods"
            />
            全选
          </label>
        </div>
        <main>
          <button
            v-for="g in displayedGoods"
            :key="g.product_id"
            :class="{ selected: selected.includes(String(g.product_id)) }"
            @click="toggleGood(g.product_id)"
          >
            <el-checkbox
              :value="selected.includes(String(g.product_id))"
              @click.native.stop
              @change="toggleGood(g.product_id)"
            />
            <img :src="imageOf(g)" alt="商品主图" />
            <span>{{ g.title || g.product_title }}</span>
            <small>{{ priceRange(g) }}</small>
          </button>
        </main>
        <footer>
          <span>已选 {{ selected.length }} 个商品</span>
          <button class="plain" @click="selecting = false">取消</button>
          <button @click="selecting = false">确定</button>
        </footer>
      </div>
    </div>
    <ImageSelectorDialog
      :visible.sync="imageSelector.visible"
      :type="imageSelector.type"
      :index="imageSelector.index"
      :product-id="imageSelector.productId"
      :multiple="imageSelector.multiple"
      :disable-upload="imageSelector.disableUpload"
      @select="handleImageSelected"
    />
  </section>
</template>
<script>
import draggable from "vuedraggable";
import ImageSelectorDialog from "./components/ImageSelectorDialog.vue";
import {
  previewCloudDetailImageBatch,
  createCloudDetailImageBatch,
  getProductDetailImages,
  saveProductDetailImages,
} from "@/api/main/cloudBatchEdit";
import { cloudProductGroups, cloudProductList } from "@/api/main/ucenter";
const fields = [
  { key: "group_id", label: "分组", placeholder: "请选择分组" },
  { key: "child_group_id", label: "子分组", placeholder: "请选择子分组" },
  { key: "created_range", label: "导入时间", range: true },
  { key: "source_product_id", label: "来源ID", placeholder: "请输入来源ID" },
  { key: "sku_status", label: "SKU替换状态", select: true },
  { key: "sku_mark_status", label: "商品标记状态", select: true },
  { key: "ai_title_status", label: "标题替换状态", select: true },
  { key: "source_web", label: "数据源", select: true },
];
export default {
  name: "BatchModifyDetail",
  components: { draggable, ImageSelectorDialog },
  data() {
    return {
      mode: "range",
      fields,
      addTime: [],
      groupList: [],
      childGroupList: [],
      statusOptions: {
        sku_status: [
          { label: "待替换", value: 1 },
          { label: "已替换", value: 2 },
          { label: "找不到", value: 3 },
        ],
        sku_mark_status: [
          { label: "未标记", value: 1 },
          { label: "已标记", value: 2 },
          { label: "找不到", value: 3 },
        ],
        ai_title_status: [
          { label: "待替换", value: 1 },
          { label: "已替换", value: 2 },
          { label: "异常", value: 9 },
        ],
        source_web: [
          { value: 9, label: "星好货" },
          { value: 3, label: "TB" },
          { value: 4, label: "PDD" },
          { value: 2, label: "1688" },
          { value: 5, label: "DY" },
          { value: 6, label: "WX" },
        ],
      },
      filterValues: {
        group_id: "",
        child_group_id: "",
        source_product_id: "",
        sku_status: "",
        sku_mark_status: "",
        ai_title_status: "",
        source_web: "",
      },
      selecting: false,
      selectorTab: "all",
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorFilters: {
        group_id: "",
        child_group_id: "",
        source_product_id: "",
        keyword: "",
      },
      selectorChildGroups: [],
      selected: [],
      selectedGoods: [],
      goods: [],
      preview: null,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      excludedProductIds: [],
      previewKey: "",
      previewLoading: false,
      submitting: false,
      form: {
        productIds: "",
        keyword: "",
        selectedMethod: 1,
        deletePositions: [],
        deleteCustomIndex: null,
        deleteCustomLastIndex: null,
        filterImages: [],
        replaceList: [{ find: "", to: "" }],
        addHeadImages: [],
        addTailImages: [],
        addPositionImages: [],
        insertPosition: null,
        mainImageToDetail: "",
        deleteOption: null,
        deleteHeadCount: null,
        deleteTailCount: null,
        deleteFirstCount: null,
        deleteLastCount: null,
        keepCount: null,
        deleteAllAndAdd: false,
        deleteAllAddImages: [],
      },
      methods: [
        { id: 1, name: "先预览，再手动修改", on: false },
        { id: 2, name: "删除指定位置图片", on: false },
        { id: 3, name: "过滤详情图片", on: false },
        { id: 4, name: "查找替换详情图片", on: false },
        { id: 5, name: "添加首尾图片", on: false },
        { id: 6, name: "插入详情图片", on: false },
        { id: 7, name: "主图添加到详情", on: false },
        { id: 8, name: "删除详情图", on: false },
      ],
      editingImagesMap: {},
      inlineEditingImagesMap: {},
      dragOriginalOrder: {},
      savingImages: false,
      imageSelector: {
        visible: false,
        type: "",
        index: null,
        productId: null,
        multiple: false,
        disableUpload: false,
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    filterValues: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    addTime: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    selected: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    excludedProductIds: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
  },
  computed: {
    imageOf() {
      return (g) =>
        g.main_image ||
        g.image_url ||
        (Array.isArray(g.main_images) && g.main_images[0]) ||
        "";
    },
    displayedGoods() {
      if (this.selectorTab === "selected") {
        const s = (this.selectorPage.page - 1) * this.selectorPage.limit;
        return this.selectedGoods.slice(s, s + this.selectorPage.limit);
      }
      return this.goods;
    },
    selectorPageAllSelected() {
      return (
        this.displayedGoods.length > 0 &&
        this.displayedGoods.every((g) =>
          this.selected.includes(String(g.product_id))
        )
      );
    },
    canCreate() {
      return !!this.preview && this.previewKey === this.payloadKey();
    },
    pageCount() {
      return Math.max(
        1,
        Math.ceil(this.previewPage.total / this.previewPage.limit)
      );
    },
  },
  created() {
    this.loadGroups();
  },
  methods: {
    sourceLabel(value) {
      const labels = {
        9: "星好货",
        3: "TB",
        4: "PDD",
        2: "1688",
        5: "DY",
        6: "WX",
      };
      return labels[String(value)] || value || "未知";
    },
    priceRange(good) {
      const min = good.min_price ?? good.price_min ?? good.price;
      const max = good.max_price ?? good.price_max ?? min;
      return min === undefined || min === null ? "价格待定" : `¥${min}~¥${max}`;
    },
    switchSelectorTab(t) {
      this.selectorTab = t;
      if (t === "selected") {
        this.selectorPage.total = this.selectedGoods.length;
        this.selectorPage.page = 1;
      } else this.loadGoods(1);
    },
    loadSelectorGroups() {
      const g = this.groupList.find(
        (x) => String(x.id) === String(this.selectorFilters.group_id)
      );
      this.selectorChildGroups = (g && g.child_groups) || [];
      this.selectorFilters.child_group_id = "";
      this.loadGoods(1);
    },
    toggleGood(id) {
      id = String(id);
      if (!id || id === "undefined" || id === "null") return;
      const i = this.selected.indexOf(id);
      if (i >= 0) {
        this.selected.splice(i, 1);
        this.selectedGoods = this.selectedGoods.filter(
          (g) => String(g.product_id) !== id
        );
      } else {
        this.selected.push(id);
        const g = this.goods.find((x) => String(x.product_id) === id);
        if (g) this.selectedGoods.push(g);
      }
    },
    togglePageGoods(c) {
      this.displayedGoods.forEach((g) => {
        const id = String(g.product_id);
        if (!id || id === "undefined" || id === "null") return;
        if (c && !this.selected.includes(id)) {
          this.selected.push(id);
          this.selectedGoods.push(g);
        }
        if (!c) {
          const i = this.selected.indexOf(id);
          if (i >= 0) this.selected.splice(i, 1);
          this.selectedGoods = this.selectedGoods.filter(
            (x) => String(x.product_id) !== id
          );
        }
      });
    },
    loadGoods(page = 1) {
      return cloudProductList({
        page,
        page_size: this.selectorPage.limit,
        status: 1,
        ...this.selectorFilters,
      })
        .then((r) => {
          const d = (r.data && (r.data.data || r.data)) || {};
          this.goods = d.list || d.data || d;
          this.selectorPage = {
            ...this.selectorPage,
            page,
            total: Number(d.total || this.goods.length),
          };
        })
        .catch(() => this.$message.error("商品查询失败"));
    },
    switchMode(m) {
      this.mode = m;
      this.invalidate();
    },
    invalidate() {
      this.preview = null;
      this.previewKey = "";
    },
    async loadGroups() {
      try {
        const r = await cloudProductGroups({ with_count: 0 });
        this.groupList = (r.data && (r.data.data || r.data)) || [];
      } catch (e) {
        this.$message.error("请求失败，请稍后重试");
      }
    },
    onGroupChange() {
      const g = this.groupList.find(
        (i) => String(i.id) === String(this.filterValues.group_id)
      );
      this.childGroupList = (g && g.child_groups) || [];
      this.filterValues.child_group_id = "";
      this.invalidate();
    },
    optionsFor(k) {
      return k === "group_id"
        ? this.groupList.map((i) => ({
            value: i.id,
            label: i.name || i.group_name,
          }))
        : k === "child_group_id"
        ? this.childGroupList.map((i) => ({
            value: i.id,
            label: i.name || i.group_name,
          }))
        : this.statusOptions[k] || [];
    },
    buildPayload() {
      const f = this.form;

      // 构建商品过滤条件或商品ID列表（二选一）
      let productFilter = {};

      if (this.mode === "goods" && this.selected.length > 0) {
        // 如果是表格选择模式且有选中商品，只传商品ID
        productFilter = {
          product_ids: this.selected.map(String)
        };
      } else {
        // 否则传递完整的过滤条件
        const ids = f.productIds
          .split(/[,，\r\n]+/)
          .map((v) => v.trim())
          .filter(Boolean);

        productFilter = {
          ...this.filterValues,
          product_ids: ids,
          excluded_product_ids: this.excludedProductIds.map(String),
          add_time_start: this.addTime[0] || "",
          add_time_end: this.addTime[1] || "",
          keyword: f.keyword,
        };
      }

      const p = {
        product_filter: productFilter,
        detail_image_rule: this.buildDetailImageRule(),
      };
      return p;
    },
    buildDetailImageRule() {
      const f = this.form;
      if (!f.selectedMethod) return {};

      const rule = { method: f.selectedMethod };

      if (f.selectedMethod === 1) {
        // 方式1: 清空所有详情图（仅预览，不提交）
        // 无需额外参数
      } else if (f.selectedMethod === 2) {
        // 方式2: 删除指定位置的图片
        rule.delete_positions = f.deletePositions || [];
        if (f.deleteCustomIndex) rule.delete_custom_index = f.deleteCustomIndex;
        if (f.deleteCustomLastIndex) rule.delete_custom_last_index = f.deleteCustomLastIndex;
      } else if (f.selectedMethod === 3) {
        // 方式3: 过滤详情图片
        rule.filter_images = f.filterImages || [];
      } else if (f.selectedMethod === 4) {
        // 方式4: 查找并替换
        rule.replace_list = f.replaceList || [];
      } else if (f.selectedMethod === 5) {
        // 方式5: 添加首尾图片
        if (f.addHeadImages && f.addHeadImages.length > 0)
          rule.add_head_images = f.addHeadImages;
        if (f.addTailImages && f.addTailImages.length > 0)
          rule.add_tail_images = f.addTailImages;
      } else if (f.selectedMethod === 6) {
        // 方式6: 插入详情图片
        rule.insert_images = f.addPositionImages || [];
        rule.insert_position = f.insertPosition;
      } else if (f.selectedMethod === 7) {
        // 方式7: 主图添加到详情
        rule.main_image_position = f.mainImageToDetail;
      } else if (f.selectedMethod === 8) {
        // 方式8: 删除详情图
        rule.delete_option = f.deleteOption;
        if (f.deleteOption === "head_tail") {
          if (f.deleteHeadCount) rule.delete_head_count = f.deleteHeadCount;
          if (f.deleteTailCount) rule.delete_tail_count = f.deleteTailCount;
        } else if (f.deleteOption === "first_last") {
          if (f.deleteFirstCount) rule.delete_first_count = f.deleteFirstCount;
          if (f.deleteLastCount) rule.delete_last_count = f.deleteLastCount;
        } else if (f.deleteOption === "keep") {
          rule.keep_count = f.keepCount;
        } else if (f.deleteOption === "delete_all") {
          rule.replace_images = f.deleteAllAddImages || [];
        }
      }

      return rule;
    },
    payloadKey() {
      return JSON.stringify(this.buildPayload());
    },
    validate(isSubmit = false) {
      const p = this.buildPayload();
      if (this.mode === "goods" && !p.product_filter.product_ids.length)
        return "请选择商品";
      if (!this.form.selectedMethod) return "请选择一种修改方式";
      if (isSubmit && this.form.selectedMethod === 1) return "方式1仅支持预览，不支持批量修改";

      // 验证各方式必填内容
      const f = this.form;
      if (f.selectedMethod === 2) {
        // 方式2: 删除指定位置
        if ((!f.deletePositions || f.deletePositions.length === 0) && !f.deleteCustomIndex && !f.deleteCustomLastIndex) {
          return "请选择要删除的位置或输入自定义位置";
        }
      } else if (f.selectedMethod === 3) {
        // 方式3: 过滤图片
        if (!f.filterImages || f.filterImages.length === 0) {
          return "请选择要过滤的图片";
        }
      } else if (f.selectedMethod === 4) {
        // 方式4: 查找替换
        if (!f.replaceList || f.replaceList.length === 0) {
          return "请添加替换规则";
        }
        for (let item of f.replaceList) {
          if (!item.find || !item.to) {
            return "替换规则不完整，请补充查找图片和替换图片";
          }
        }
      } else if (f.selectedMethod === 5) {
        // 方式5: 添加首尾图片
        if ((!f.addHeadImages || f.addHeadImages.length === 0) && (!f.addTailImages || f.addTailImages.length === 0)) {
          return "请至少选择添加首部或尾部图片";
        }
      } else if (f.selectedMethod === 6) {
        // 方式6: 插入图片
        if (!f.addPositionImages || f.addPositionImages.length === 0) {
          return "请选择要插入的图片";
        }
        if (!f.insertPosition || f.insertPosition < 1) {
          return "请输入插入位置";
        }
      } else if (f.selectedMethod === 7) {
        // 方式7: 主图添加到详情
        if (!f.mainImageToDetail) {
          return "请选择主图插入位置";
        }
      } else if (f.selectedMethod === 8) {
        // 方式8: 删除详情图
        if (!f.deleteOption) {
          return "请选择删除选项";
        }
        if (f.deleteOption === "head_tail") {
          if (!f.deleteHeadCount && !f.deleteTailCount) {
            return "请输入要删除的首部或尾部图片数量";
          }
        } else if (f.deleteOption === "first_last") {
          if (!f.deleteFirstCount && !f.deleteLastCount) {
            return "请输入要删除的前几张或后几张图片数量";
          }
        } else if (f.deleteOption === "keep") {
          if (!f.keepCount || f.keepCount < 1) {
            return "请输入要保留的图片数量";
          }
        } else if (f.deleteOption === "delete_all") {
          if (!f.deleteAllAddImages || f.deleteAllAddImages.length === 0) {
            return "请选择删除后要新增的图片";
          }
        }
      }

      return "";
    },
    async previewBatch() {
      const e = this.validate(false);
      if (e) return this.$message.warning(e);

      // 检查是否有修改内容
      const rule = this.buildDetailImageRule();
      if (!rule.method) {
        return this.$message.warning("请选择修改方式");
      }

      this.previewLoading = true;
      try {
        const payload = this.buildPayload();
        const r = await previewCloudDetailImageBatch({
          ...payload,
          page: this.previewPage.page,
          limit: this.previewPage.limit,
        });
        if (r.code === 200 || r.code === 0) {
          this.preview = {
            product_count: r.data.product_count || 0,
            total: r.data.total || 0,
          };
          this.previewGoods = r.data.list || [];
          this.previewPage.total = r.data.total || 0;
          this.previewKey = this.payloadKey();
        } else {
          throw new Error(r.msg || r.message || "预览失败");
        }
      } catch (e) {
        this.invalidate();
        this.$message.error(
          (e.response &&
            e.response.data &&
            (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            "请求失败，请稍后重试"
        );
      } finally {
        this.previewLoading = false;
      }
    },
    async previewBatchPage(page) {
      this.previewPage.page = page;
      await this.previewBatch();
    },
    async createBatch() {
      if (!this.canCreate) return this.$message.warning("请先预览当前修改规则");

      // 验证是否可以提交
      const error = this.validate(true);
      if (error) return this.$message.warning(error);

      this.submitting = true;
      try {
        const payload = this.buildPayload();
        const r = await createCloudDetailImageBatch(payload);
        if (r.code === 200 || r.code === 0) {
          this.$message.success("批量修改任务已创建，请前往任务列表查看进度");
          this.$emit("back");
        } else {
          throw new Error(r.msg || r.message || "创建任务失败");
        }
      } catch (e) {
        this.$message.error(
          (e.response &&
            e.response.data &&
            (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            "请求失败，请稍后重试"
        );
      } finally {
        this.submitting = false;
      }
    },
    toggleExclude(g) {
      const id = String(g.product_id),
        i = this.excludedProductIds.indexOf(id);
      if (!id || id === "undefined" || id === "null") return;
      i < 0
        ? this.excludedProductIds.push(id)
        : this.excludedProductIds.splice(i, 1);
      this.invalidate();
    },
    reset() {
      Object.assign(this.filterValues, {
        group_id: "",
        child_group_id: "",
        source_product_id: "",
        sku_status: "",
        sku_mark_status: "",
        ai_title_status: "",
        source_web: "",
      });
      this.addTime = [];
      Object.assign(this.form, {
        productIds: "",
        keyword: "",
      });
      this.selected = [];
      this.invalidate();
    },
    async openSelector() {
      this.selecting = true;
      this.selectorTab = "all";
      await this.loadGroups();
      this.loadSelectorGroups();
      await this.loadGoods(1);
    },
    openImageSelector(type, index) {
      // 类型与方式ID的映射关系
      const typeMethodMap = {
        filter: 3,
        replace_find: 4,
        replace_to: 4,
        add_head: 5,
        add_tail: 5,
        add_position: 6,
        delete_all_add: 8,
      };

      const requiredMethod = typeMethodMap[type];
      if (this.form.selectedMethod !== requiredMethod) {
        this.$message.warning("请选择当前方式再选择图片");
        return;
      }

      // 方式3（过滤）和方式4的查找图片禁用上传功能
      // 方式4的替换为图片允许上传
      const disableUpload = type === 'filter' || type === 'replace_find';

      this.imageSelector = {
        visible: true,
        type: type,
        index: index,
        productId: null,
        multiple: type !== "replace_find" && type !== "replace_to",
        disableUpload: disableUpload,
      };
    },
    onMethodChange(methodId) {
      if (this.form.selectedMethod === methodId) {
        this.form.selectedMethod = null;
      } else {
        this.form.selectedMethod = methodId;
      }
    },
    onDragStart(productId) {
      this.ensureEditingImages(productId);
      // 保存拖拽前的原始顺序（通过 id 来标识）
      const images = this.inlineEditingImagesMap[productId];
      if (images) {
        this.dragOriginalOrder[productId] = images.map(
          (img) => img.id || img.url
        );
      }
    },
    onDragEnd(productId) {
      // 拖拽结束后，只更新 sort 字段，不修改 status
      const images = this.inlineEditingImagesMap[productId];
      if (images) {
        images.forEach((img, index) => {
          img.sort = index + 1;
        });
        this.$forceUpdate();
      }
    },
    updateEditingImages(productId, newImages) {
      this.ensureEditingImages(productId);

      // 获取原始顺序
      const originalOrder = this.dragOriginalOrder[productId] || [];

      // 只标记位置真正改变的图片
      newImages.forEach((img, index) => {
        img.sort = index + 1;

        // 比较当前位置和原始位置
        const originalIndex = originalOrder.indexOf(img.id || img.url);

        // 只有当位置真正改变，且是未修改状态时，才标记为仅排序改变
        if (
          originalIndex !== -1 &&
          originalIndex !== index &&
          img.id &&
          img.status === 1
        ) {
          img.status = 5;
        }
      });

      this.$set(this.inlineEditingImagesMap, productId, newImages);
      this.$forceUpdate();
    },
    getEditingImages(productId) {
      if (this.inlineEditingImagesMap[productId]) {
        // 过滤掉已删除的图片（status=3）
        return this.inlineEditingImagesMap[productId].filter(
          (img) => img.status !== 3
        );
      }
      const product = this.previewGoods.find((p) => p.product_id === productId);
      if (product && product.detail_images) {
        return product.detail_images;
      }
      return [];
    },
    hasChanges(productId) {
      return !!this.inlineEditingImagesMap[productId];
    },
    getAllImagesForPreview(item) {
      // 合并保留的图片和删除的图片，用于点击预览
      const allImages = [];
      if (item.detail_images && item.detail_images.length > 0) {
        allImages.push(...item.detail_images.map((i) => i.url));
      }
      if (item.deleted_images && item.deleted_images.length > 0) {
        allImages.push(...item.deleted_images.map((i) => i.url));
      }
      return allImages;
    },
    getPreviewIndex(images, currentIndex) {
      // 计算点击预览时的索引，需要排除之前的已删除图片
      let previewIndex = 0;
      for (let i = 0; i < currentIndex; i++) {
        if (images[i].change_type !== 'deleted') {
          previewIndex++;
        }
      }
      return previewIndex;
    },
    moveImageInline(productId, index, direction) {
      this.ensureEditingImages(productId);
      const images = this.inlineEditingImagesMap[productId];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= images.length) return;

      const temp = images[index];
      images[index] = images[newIndex];
      images[newIndex] = temp;
      this.$forceUpdate();
    },
    replaceImageInline(productId, index) {
      this.$prompt("请输入新图片URL", "替换图片", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^https?:\/\/.+/,
        inputErrorMessage: "请输入有效的图片URL",
      })
        .then(({ value }) => {
          this.ensureEditingImages(productId);
          const img = this.inlineEditingImagesMap[productId][index];
          img.url = value;
          if (img.status === 1) {
            img.status = 2;
          }
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    deleteImageInline(productId, index) {
      const images = this.getEditingImages(productId);
      if (images.length <= 1) {
        this.$message.warning("详情图至少保留一张！");
        return;
      }
      this.$confirm("确定删除这张图片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ensureEditingImages(productId);
          const img = this.inlineEditingImagesMap[productId][index];
          if (img.id) {
            img.status = 3;
          } else {
            this.inlineEditingImagesMap[productId].splice(index, 1);
          }
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    addNewImageInline(productId) {
      this.imageSelector = {
        visible: true,
        type: "inline_add",
        index: null,
        productId: productId,
        multiple: true,
      };
    },
    handleImageSelected(urls) {
      const { type, index, productId } = this.imageSelector;

      if (type === "filter") {
        this.form.filterImages.push(...urls);
      } else if (type === "replace_find") {
        this.form.replaceList[index].find = urls[0];
      } else if (type === "replace_to") {
        this.form.replaceList[index].to = urls[0];
      } else if (type === "add_head") {
        if (!this.form.addHeadImages) this.form.addHeadImages = [];
        this.form.addHeadImages.push(...urls);
      } else if (type === "add_tail") {
        if (!this.form.addTailImages) this.form.addTailImages = [];
        this.form.addTailImages.push(...urls);
      } else if (type === "add_position") {
        if (!this.form.addPositionImages) this.form.addPositionImages = [];
        this.form.addPositionImages.push(...urls);
      } else if (type === "delete_all_add") {
        if (!this.form.deleteAllAddImages) this.form.deleteAllAddImages = [];
        this.form.deleteAllAddImages.push(...urls);
      } else if (type === "inline_add") {
        this.ensureEditingImages(productId);
        urls.forEach((url) => {
          this.inlineEditingImagesMap[productId].push({ url: url, status: 4 });
        });
        this.$forceUpdate();
      }

      this.imageSelector.visible = false;
    },
    ensureEditingImages(productId) {
      if (!this.inlineEditingImagesMap[productId]) {
        const product = this.previewGoods.find(
          (p) => p.product_id === productId
        );
        if (product && product.detail_images) {
          this.$set(
            this.inlineEditingImagesMap,
            productId,
            JSON.parse(JSON.stringify(product.detail_images)).map(
              (img, index) => ({
                ...img,
                status: 1,
                sort: img.sort || index + 1,
              })
            )
          );
        } else {
          this.$set(this.inlineEditingImagesMap, productId, []);
        }
      }
    },
    cancelEditInline(productId) {
      this.$delete(this.inlineEditingImagesMap, productId);
      this.$forceUpdate();
    },
    async saveProductImages(productId) {
      const images = this.inlineEditingImagesMap[productId];
      if (!images || images.filter((img) => img.status !== 3).length === 0) {
        this.$message.warning("详情图至少保留一张！");
        return;
      }

      // 在保存前，重新计算排序并标记需要移动的图片
      let newSort = 0;
      images.forEach((img) => {
        if (img.status !== 3) {
          // 非删除的图片
          if (img.id && img.sort !== newSort && img.status === 1) {
            // 如果原始排序与新排序不一致，且当前状态为未变化，则标记为移动
            img.status = 5;
          }
          img.sort = newSort;
          newSort++;
        }
      });

      this.savingImages = true;
      try {
        const r = await saveProductDetailImages(productId, { images });
        if (r.code === 200 || r.code === 0) {
          this.$message.success("保存成功");
          this.$delete(this.inlineEditingImagesMap, productId);
          await this.previewBatch();
        } else {
          throw new Error(r.msg || "保存失败");
        }
      } catch (e) {
        this.$message.error(e.message || "保存失败");
      } finally {
        this.savingImages = false;
      }
    },
    async loadDetailImages(productId) {
      try {
        const r = await getProductDetailImages(productId);
        if (r.code === 200 || r.code === 0) {
          this.editingProductId = productId;
          this.editingImages = (r.data.detail_images || []).map((img) => ({
            id: img.id,
            url: img.url,
            sort: img.sort,
          }));
        } else {
          throw new Error(r.msg || "加载详情图失败");
        }
      } catch (e) {
        this.$message.error(e.message || "加载详情图失败");
      }
    },
    cancelEdit() {
      this.editingProductId = null;
      this.editingImages = [];
    },
    replaceImage(index) {
      this.$prompt("请输入新图片URL", "替换图片", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^https?:\/\/.+/,
        inputErrorMessage: "请输入有效的图片URL",
      })
        .then(({ value }) => {
          this.editingImages[index].url = value;
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    deleteImage(index) {
      if (this.editingImages.length <= 1) {
        this.$message.warning("详情图至少保留一张！");
        return;
      }
      this.$confirm("确定删除这张图片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.editingImages.splice(index, 1);
        })
        .catch(() => {});
    },
    addNewImage() {
      this.$prompt("请输入图片URL", "添加图片", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^https?:\/\/.+/,
        inputErrorMessage: "请输入有效的图片URL",
      })
        .then(({ value }) => {
          this.editingImages.push({ url: value });
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    previewImage(url) {
      if (!url) return;
      const images = [url];
      this.$viewerApi({
        images: images,
      });
    },
  },
};
</script>
<style scoped src="./BatchModifyStock.vue"></style>
<style scoped>
.bm-title__methods-wrapper {
  padding: 12px 16px;
}

.bm-title__methods article {
  padding: 12px 16px;
}

.upload-box {
  display: inline-flex;
  width: 100px;
  height: 100px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  color: #999;
  cursor: pointer;
  transition: all 0.3s;
}

.upload-box:hover {
  border-color: #1677ff;
  color: #1677ff;
}

.upload-box.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-box.is-disabled:hover {
  border-color: #dcdfe6;
  color: #999;
}

.upload-box.small {
  width: 80px;
  height: 80px;
}

.upload-box span {
  font-size: 24px;
  line-height: 1;
}

.upload-box small {
  margin-top: 8px;
  font-size: 11px;
}

.upload-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
}

.replace-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.replace-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.add-btn {
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 12px;
  cursor: pointer;
}

.add-btn:hover {
  border-color: #1677ff;
  color: #1677ff;
}

.add-btn-inline {
  padding: 4px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.bm-title__preview table {
  width: 100%;
  border-collapse: collapse;
}

.bm-title__preview thead th {
  padding: 12px;
  background: #fafafa;
  font-weight: 500;
  text-align: left;
  border: none;
}

.bm-title__preview thead tr {
  border-bottom: 1px solid #e8e8e8;
}

.bm-title__preview tbody tr {
  border-bottom: 1px solid #e8e8e8;
}

.bm-title__preview tbody td {
  padding: 12px;
  vertical-align: middle;
  border: none;
}

.bm-title__preview tbody td:first-child {
  vertical-align: top;
  padding: 32px;
}

.detail-images-preview {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
  max-width: 100%;
}

.image-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: move;
}

/* 新增图片样式 */
.image-preview-item.image-added {
  border: 2px solid #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.1);
}

/* 替换图片样式 */
.image-preview-item.image-replaced {
  border: 2px solid #faad14;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.1);
}

/* 移动图片样式 */
.image-preview-item.image-moved {
  border: 2px solid #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

/* 删除图片样式 */
.image-preview-item.image-deleted {
  border: 2px solid #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
  cursor: not-allowed;
}

/* 变化标签 */
.change-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 2px 6px;
  font-size: 11px;
  line-height: 1.2;
  border-radius: 2px;
  color: #fff;
  font-weight: 500;
  z-index: 1;
  white-space: nowrap;
}

.badge-replaced {
  background-color: #faad14;
}
.badge-added {
  background-color: #52c41a;
}

.badge-moved {
  background-color: #1890ff;
}

.badge-deleted {
  background-color: #ff4d4f;
}

/* 删除图片遮罩 */
.deleted-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.image-deleted::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 2px;
  background-color: #ff4d4f;
  transform: translateY(-50%) rotate(-15deg);
  z-index: 1;
}

.image-preview-item:hover .image-actions-overlay {
  opacity: 1;
}

.image-actions-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0;
  opacity: 1;
  transition: opacity 0.2s;
}

.image-actions-overlay .icon-btn-overlay {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid transparent;
  background: transparent;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 16px;
}

.image-actions-overlay .icon-btn-overlay:hover:not(:disabled) {
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.image-actions-overlay .icon-btn-overlay:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.image-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #999;
}

.image-loading i {
  font-size: 20px;
}

.image-preview-item.add-image {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d9d9d9;
  background: #fafafa;
  transition: all 0.2s;
}

.image-preview-item.add-image:hover {
  border-color: #1677ff;
  background: #f0f7ff;
}

.add-icon {
  font-size: 24px;
  color: #999;
}

.action-cell {
  white-space: nowrap;
}

.action-cell button {
  margin-right: 8px;
  margin-bottom: 4px;
}

.btn-save-action {
  padding: 4px 12px;
  border: 1px solid #1677ff;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-save-action:hover:not(:disabled) {
  background: #0958d9;
  border-color: #0958d9;
}

.btn-save-action:disabled {
  background: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}

.btn-cancel-action {
  padding: 4px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel-action:hover {
  border-color: #1677ff;
  color: #1677ff;
}

.btn-edit-action {
  padding: 4px 12px;
  border: 1px solid #1677ff;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit-action:hover {
  background: #1677ff;
  color: #fff;
}

.add-btn-inline:hover {
  border-color: #1677ff;
  color: #1677ff;
}

.delete-detail-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.delete-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.danger {
  padding: 4px 8px;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  background: #fff;
  color: #ff4d4f;
  font-size: 12px;
  cursor: pointer;
}

.danger:hover {
  background: #ff4d4f;
  color: #fff;
}

.image-select-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.selected-images {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-item .remove-img {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  border-radius: 0 4px 0 4px;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.image-item .remove-img:hover {
  background: rgba(0, 0, 0, 0.8);
}

.image-item .remove-img:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
